import { IBaseAuthProvider } from "./base-auth-provider";

export class GoogleProvider implements IBaseAuthProvider {

    _googleAuth: any;

    loadProvider(): Promise<void> {
        return new Promise<void>((resolve, reject) => {

            window["init"] = () => {
                window["gapi"].load('auth2', () => {
                    this._googleAuth = window["gapi"].auth2.init({ client_id:  window["googleClientId"] });
                    this._googleAuth.then(resolve, reject);
                });
            }

            (function (d, s, id) {
                const fjs = d.getElementsByTagName(s)[0] || document.head;
                if (d.getElementById(id)) {
                    resolve();
                    return;
                }
                const js = d.createElement(s) as HTMLScriptElement; 
                js.id = id;
                js.src = "https://apis.google.com/js/platform.js?onload=init";
                js.async = true;
                if(fjs && fjs.parentNode){
                    fjs.parentNode.insertBefore(js, fjs);
                }
            }(document, 'script', 'google-sdk'));
        });
    }

    redirectToLogin() { }

    // Here we run a very simple test of the Graph API after login is
    // successful.  See statusChangeCallback() for when this call is made.
    fetchUserDetails(): Promise<{ firstName: string, lastName: string, email: string, picture: string }> {
        return new Promise<{ firstName: string, lastName: string, email: string, picture: string }>((resolve) => {
            const user = this._googleAuth.currentUser.get();
            const basicProfile = user.getBasicProfile();
            resolve({ firstName: basicProfile.getGivenName(), lastName: basicProfile.getFamilyName(), email: basicProfile.getEmail(), picture: null });

        });
    }

    //Google Login
    getAuthToken(callback: (response: { accessToken: string, userId: string, subProviderName: string, metadata: string, doNotSaveUserLogin: boolean }) => void): void {        
        this._googleAuth.signIn({ scope: 'profile email' }).then((response) => {
            if (response.isSignedIn()) {
                // Logged into your app and Google.
                callback({ accessToken: response.getAuthResponse().access_token, userId: response.getId(), subProviderName: null, metadata: null, doNotSaveUserLogin: false });
            } else {
                callback(null);
            }
        });
    }

    logout(): Promise<any> {
        return new Promise<void>((resolve) => {
            this._googleAuth.signOut().then(resolve);
        });
    }
}
